module.exports = __webpack_public_path__ + "d5101890a44f94913d2c3f73f15a6253.svg";